import { FmaSliceSettingsSchema, fmaSliceParameters } from './shared.js';

export default {
  label: 'RMS spot diameter versus field', group: 'performance',
  description: 'RMS spot diameter along a field slice.',
  settingsSchema: FmaSliceSettingsSchema,
  parameters: fmaSliceParameters,
  coverage: 'For focal (non-afocal) systems, along the X or Y axis of the field. Diameters are in millimeters, with the minimum, maximum, average and standard deviation. Not supported: oblique slices, lens units other than millimeters and two-dimensional maps.',
} as const;
